import {ISuperUsersState} from '../../../api/superUsers/types';

export const selectCompanies = (state: ISuperUsersState) => state.superUsers.data.result;
export const selectTotalRecords = (state: ISuperUsersState) => state.superUsers.data.page.total;
